import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { Divider } from 'antd';
import { Button, Col, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { timeForToday } from '../../util/utils';
import { TaskComment } from '../../modules/tasks';
import {
  DownloadOutlined,
  EyeOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface TaskCommentListComponentProps {
  taskComments: TaskComment[];
  onOpenCreateTaskCommentModal: () => void;
  downloadFile: (attachFileId: string, fileName: string) => void;
  openImagePreview: (imageData: any) => void;
}

function TaskCommentListComponent({
  taskComments,
  onOpenCreateTaskCommentModal,
  downloadFile,
  openImagePreview,
}: TaskCommentListComponentProps) {
  const columns: ColumnsType<TaskComment> = [
    {
      title: '작성자',
      dataIndex: ['user', 'name'],
      width: '20%',
      render: (text: any, record: any, index: any) =>
        record.user === null ? '하이공사' : record.user.name,
    },
    {
      title: '설명',
      dataIndex: 'description',
      width: '60%',
      render: (text: any, record: any, index: any) => {
        let children: any = [];
        children.push(
          <div key={0} style={{ whiteSpace: 'pre-wrap' }}>
            {record.description}
          </div>,
        );
        if (record.file.length !== 0) {
          children.push(
            <Divider
              key={1}
              type="horizontal"
              style={{ marginTop: '5px', marginBottom: '5px' }}
            />,
          );
        }

        for (const _file of record.file) {
          children.push(
            <Row justify={'space-between'} key={_file.id}>
              <Space>
                <PaperClipOutlined rev={undefined} />
                <span>{_file.name}</span>
              </Space>
              <Space>
                <Button
                  size="small"
                  icon={<DownloadOutlined rev={undefined} />}
                  onClick={() => downloadFile(_file.id, _file.name)}
                >
                  {/* 다운로드 */}
                </Button>
                <Button
                  size="small"
                  icon={<EyeOutlined rev={undefined} />}
                  disabled={
                    _file.name.split('.').pop() !== 'jpg' &&
                    _file.name.split('.').pop() !== 'jpeg' &&
                    _file.name.split('.').pop() !== 'png' &&
                    _file.name.split('.').pop() !== 'pdf'
                  }
                  onClick={() => {
                    openImagePreview(_file);
                  }}
                >
                  {/* 미리보기 */}
                </Button>
              </Space>
            </Row>,
          );
        }
        return <>{children}</>;
      },
    },
    {
      title: '생성일시',
      dataIndex: 'createdAt',
      width: '12%',
      render: (text: any, record: any, index: any) =>
        timeForToday(moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss')),
    },
  ];

  return (
    <StyledDiv>
      <Row justify={'space-between'}>
        <Col>
          <Title level={5}>코멘트</Title>
        </Col>
        <Col>
          <Button onClick={onOpenCreateTaskCommentModal} size="small">
            추가
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table<any>
            rowKey="id"
            columns={columns}
            dataSource={taskComments}
            pagination={false}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}
export default TaskCommentListComponent;
